import { render } from "./TgBadge.vue?vue&type=template&id=304f091a"
import script from "./TgBadge.vue?vue&type=script&lang=js"
export * from "./TgBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__